import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'

import App from './App'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from 'sonner'
import './styles/app.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <App />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>
)
